import React, { Component } from "react";
import PropTypes from 'prop-types';
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from "moment";
import CancelAcceptForm from "../../Common/CancelAcceptForm";
import t from "../../../languages/pl";
import { displayDateFormat } from "../../../utils/staticData";
import ConfirmationDialog from '../../Common/ConfirmationDialog';
import { TooltipTop } from "../../Common/CustomTooltips";
import EmailTextField from './../../Common/InputFields/EmailTextField';
import { isEmail } from './../../../utils/helpers';

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "baseline",
        paddingBottom: theme.spacing(1),
        justifyContent: "center",
        maxWidth: 800,
        [theme.breakpoints.down("md")]: {
            flexDirection: "column"
        }
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: 250
    },
    clientComments: {
        margin: theme.spacing(1),

    },
    dialogPaper: {
        minHeight: "80vh",
        maxHeight: "80vh"
    },
    formsContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
    },
    person: {
        alignSelf: "flex-start",
        paddingLeft: theme.spacing(5),
    }
});

const initialClient = {
    klient_dowod: "",
    klient_email: "",
    klient_id: "",
    klient_kod: "",
    klient_limitkm: "",
    klient_miasto: "",
    klient_nazwa: "",
    klient_nip: "",
    klient_pesel: "",
    klient_regon: "",
    klient_rodzaj: "",
    klient_telefon: "",
    klient_ulica: "",
    klient_uwagi: "",

    kierowca: {
        data_prawa: 0,
        imie: "",
        kod: "",
        miasto: "",
        organ: "",
        pesel: "",
        prawo: "",
        telefon: "",
        ulica: ""
    },
    isOpenConfirmDialog: false,
};


class ClientDialog extends Component {

    constructor(props) {
        super(props);
        this.state = initialClient;
        this.onClientChange = this.onClientChange.bind(this);
        this.onDriverChange = this.onDriverChange.bind(this);
        this.onClientTypeChange = this.onClientTypeChange.bind(this);
        this.onDriverOverwrite = this.onDriverOverwrite.bind(this);
    }

    componentDidUpdate(prevProps) {
        if(prevProps.client !== this.props.client)
            this.setState(this.props.client);
    }

    onClientChange(e) {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    }

    onClientTypeChange(e){
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    }

    setActDrivingLicenseIssueDate(newDate){
        this.setState(({kierowca}) => ({kierowca: {
            ...kierowca,
            data_prawa: newDate ? moment(newDate).unix() : initialClient.kierowca.data_prawa
          }}));
    }


    onDriverChange(e) {
        let driverPropertyName = e.target.name;
        driverPropertyName = driverPropertyName.replace('kierowca_', '');

        const value = e.target.value;

        this.setState(({kierowca}) => ({kierowca: {
            ...kierowca,
            [driverPropertyName]: value
          }}));
    }

    onDriverOverwrite() {
        this.setState(({kierowca}) => ({kierowca: {
            ...kierowca,
            imie: this.state.klient_nazwa,
            ulica: this.state.klient_ulica,
            kod: this.state.klient_kod,
            miasto: this.state.klient_miasto,
            pesel: this.state.klient_pesel,
            telefon: this.state.klient_telefon
          }}));
    }


    render() {
        const { classes, open, onClose, onSubmit, onEdit, onDeleteConfirm, isEdit} = this.props;

        const handleClose = () => {
            this.setState(initialClient);
            onClose(initialClient);
        };

        const handleSubmit = () => {
            if (this.state.klient_nazwa !== "" && this.state.klient_rodzaj !== "") {
                if (isEdit) {
                    onEdit(this.state, initialClient);
                } else {
                    onSubmit(this.state, initialClient);
                }
            }
        };

        const handleDeleteConfirm = (id) => {
            onDeleteConfirm(id, initialClient);
        };

        return (
            <Dialog
                fullWidth
                maxWidth="md"
                open={open}
                onClose={handleClose}
            >
                <DialogTitle>{t.addClient}</DialogTitle>
                <DialogContent className={classes.formsContainer}>
                    <Typography variant="h6" className={classes.person}>
                        {t.client}
                    </Typography>
                    <form className={classes.container} id="client">
                        <TextField
                            label={t.nameAndSurnameOrBusinessName}
                            className={classes.textField}
                            value={this.state.klient_nazwa}
                            name="klient_nazwa"
                            onChange={this.onClientChange}
                            required={true}
                            error={this.props.isError ? true : false}
                            helperText={this.props.isError ? t.requiredField : null}
                        />
                        <FormControl className={classes.textField}>
                            <InputLabel
                                required
                            >
                                Rodzaj
                            </InputLabel>
                            <Select
                                inputProps={{
                                    name: "klient_rodzaj"
                                }}
                                onChange={this.onClientTypeChange}
                                value={this.state.klient_rodzaj}
                            >
                                <MenuItem value="Osoba prywatna">Osoba prywatna</MenuItem>
                                <MenuItem value="Firma">Firma</MenuItem>
                                <MenuItem value="Pracownik">Pracownik</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            onChange={this.onClientChange}
                            name="klient_ulica"
                            label={t.streetAndHouseNumber}
                            className={classes.textField}
                            value={this.state.klient_ulica}
                        />
                        <TextField
                            label={t.zipCode}
                            className={classes.textField}
                            value={this.state.klient_kod}
                            name="klient_kod"
                            onChange={this.onClientChange}
                        />
                        <TextField
                            label={t.place}
                            className={classes.textField}
                            value={this.state.klient_miasto}
                            onChange={this.onClientChange}
                            name="klient_miasto"
                        />
                        <TextField
                            label={t.peselOrDateOfBirth}
                            className={classes.textField}
                            value={this.state.klient_pesel}
                            onChange={this.onClientChange}
                            name="klient_pesel"
                        />
                        <TextField
                            label={t.seriesAndNumberOfTheIdentityCard}
                            className={classes.textField}
                            name="klient_dowod"
                            value={this.state.klient_dowod}
                            onChange={this.onClientChange}
                        />
                        <TextField
                            value={this.state.klient_nip}
                            label={t.nip}
                            className={classes.textField}
                            onChange={this.onClientChange}
                            name="klient_nip"
                        />
                        <TextField
                            label={t.phone}
                            className={classes.textField}
                            value={this.state.klient_telefon}
                            name="klient_telefon"
                            onChange={this.onClientChange}
                        />
                        <EmailTextField
                            label={t.email}
                            className={classes.textField}
                            value={this.state.klient_email}
                            onChange={this.onClientChange}
                            name="klient_email"
                        />
                        <TextField
                            label={t.regon}
                            className={classes.textField}
                            value={this.state.klient_regon}
                            name="klient_regon"
                            onChange={this.onClientChange}
                        />
                        <TextField
                            value={this.state.klient_limitkm}
                            type="number"
                            label={t.kilometersLimit}
                            className={classes.textField}
                            name="klient_limitkm"
                            onChange={this.onClientChange}
                        />
                        <TextField
                            value={this.state.klient_uwagi}
                            type="text"
                            label={t.remarks}
                            fullWidth
                            className={classes.clientComments}
                            name="klient_uwagi"
                            onChange={this.onClientChange}
                        />
                    </form>

                    <Typography variant="h6" className={classes.person}>{t.driver}</Typography>
                    <form className={classes.container}>
                        <TextField
                            label={t.firstAndLastName}
                            className={classes.textField}
                            value={this.state.kierowca.imie  || ''}
                            onChange={this.onDriverChange}
                            name="kierowca_imie"
                        />
                        <TextField
                            label={t.streetAndHouseNumber}
                            className={classes.textField}
                            value={this.state.kierowca.ulica || ''}
                            onChange={this.onDriverChange}
                            name="kierowca_ulica"
                        />
                        <TextField
                            label={t.zipCode}
                            className={classes.textField}
                            value={this.state.kierowca.kod || ''}
                            onChange={this.onDriverChange}
                            name="kierowca_kod"
                        />
                        <TextField
                            value={this.state.kierowca.miasto || ''}
                            label={t.city}
                            className={classes.textField}
                            onChange={this.onDriverChange}
                            name="kierowca_miasto"
                        />
                        <TextField
                            label={t.peselOrDateOfBirth}
                            className={classes.textField}
                            value={this.state.kierowca.pesel || ''}
                            name="kierowca_pesel"
                            onChange={this.onDriverChange}
                        />
                        <TextField
                            label={t.phone}
                            className={classes.textField}
                            value={this.state.kierowca.telefon || ''}
                            onChange={this.onDriverChange}
                            name="kierowca_telefon"
                        />
                        <TextField
                            label={t.authorityissuingTheDrivingLicense}
                            className={classes.textField}
                            name="kierowca_organ"
                            value={this.state.kierowca.organ}
                            onChange={this.onDriverChange}
                        />
                        <TextField
                            label={t.driverLicenseNumber}
                            className={classes.textField}
                            value={this.state.kierowca.prawo}
                            name="kierowca_prawo"
                            onChange={this.onDriverChange}
                        />
                        <KeyboardDatePicker
                            label={t.dateOfIssueOfTheDrivingLicense}
                            className={classes.textField}
                            value={this.state.kierowca.data_prawa === 0 ? null : moment.unix(this.state.kierowca.data_prawa)}
                            format={displayDateFormat}
                            invalidDateMessage={t.invalidDateFormat}
                            name="kierowca_data_prawa"
                            onChange={(newDate) => this.setActDrivingLicenseIssueDate(newDate)}
                        />
                    </form>
                </DialogContent>
                <DialogActions>
                    <TooltipTop title={t.rewriteCustomerDataToDriver}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.onDriverOverwrite}
                        >
                            {t.overwriteDriver}
                        </Button>
                    </TooltipTop>
                    {isEdit ?
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.setState({ isOpenConfirmDialog: true })}
                        >
                            {t.deleteClient}
                        </Button>
                        : null
                    }
                    <CancelAcceptForm
                        onCancel={handleClose}
                        onSubmit={handleSubmit}
                        disableSubmit={(this.state.klient_nazwa === "" || this.state.klient_rodzaj === "" || isNaN(this.state.kierowca.data_prawa)
                        || (this.state.klient_email !== "" && !isEmail(this.state.klient_email)))}
                    />
                </DialogActions>
                <ConfirmationDialog
                    open={this.state.isOpenConfirmDialog}
                    onClose={() => this.setState({isOpenConfirmDialog: false})}
                    action={t.deleteThisClient}
                    id={this.state.klient_id}
                    onSubmit={(id) => handleDeleteConfirm(id)}
                />
            </Dialog>
        );
    }
}

ClientDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    isError: PropTypes.bool,
    client: PropTypes.object,
    initialClient: PropTypes.object,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    onEdit: PropTypes.func,
    onDeleteConfirm: PropTypes.func,
    isEdit: PropTypes.bool,
    openSnackbarInfo: PropTypes.func
};

export default withStyles(styles)(ClientDialog);
